import { render, staticRenderFns } from "./SerieList.vue?vue&type=template&id=7f31caf4&scoped=true&"
import script from "./SerieList.vue?vue&type=script&lang=js&"
export * from "./SerieList.vue?vue&type=script&lang=js&"
import style0 from "./SerieList.vue?vue&type=style&index=0&id=7f31caf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31caf4",
  null
  
)

export default component.exports